export default (props, traits) => {
  return {}
}
